import { Yup } from './Yup';

export const validateEmail = async (email: string) => {
  const emailSchema = Yup.string().email().min(2).required();
  try {
    await emailSchema.validate(email);
    return true;
  } catch (error) {
    return false;
  }
};
